import { render, staticRenderFns } from "./LayoutColumn.vue?vue&type=template&id=460d0a58&scoped=true&"
import script from "./LayoutColumn.vue?vue&type=script&lang=js&"
export * from "./LayoutColumn.vue?vue&type=script&lang=js&"
import style0 from "./LayoutColumn.vue?vue&type=style&index=0&id=460d0a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d0a58",
  null
  
)

export default component.exports